exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table__body[data-v-29f8b4e2] {\r\n  width: 100%;\r\n  table-layout: fixed !important;\n}\n.text_overflow[data-v-29f8b4e2] {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 400px;\n}\n.pup_card[data-v-29f8b4e2] {\r\n  width: 200px;\r\n  border-radius: 5px;\r\n  padding: 5px;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  font-size: 12px;\r\n  line-height: 16px;\n}\r\n", ""]);

// exports
